import { Injectable } from '@angular/core';
import { ISuitabilityLoggable } from '@services/strategy-pattern-login/iSuitability-loggable';
import { ConfigService } from './config.service';
import { HttpService } from '@services/http-service';
import { Observable , of } from 'rxjs';
import { Constants } from '@utils/constants';
import { MarketEnum } from './../../model/enum/market.enum';
import { map } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class ISuitabilityApiService implements ISuitabilityLoggable {

  constructor(
    private _httpService: HttpService,
    private _configService: ConfigService,
  ) { }

  suitabilityCheckMatrix(account: string, marketID: MarketEnum, securityType: string, securityRisk: number,
    symbol: string, suitabilityID?: string, profileName?: string, client_id?: number) {
    const params = {
      account: account,
      marketID: +marketID == MarketEnum.BOVESPA ? Constants.MARKET_BOVESPA : Constants.MARKET_BMF,
      securityType: securityType,
      securityRisk: securityRisk,
      suitabilityID: suitabilityID,
      symbol: symbol
    };
    return this._httpService
      .doPost(this._configService.getApiWebFeederRest(), 'services/Suitability/SuitabilityCheckMatrix', params, false)
      .pipe(map(response => {
        if (response) {
          const json = response;
          return json;
        }
        return [];
      }));
  }

  postAssignBounds(account: string, symbol: string, client_id: number, user_id: number) {
    throw new Error('Method not implemented.');
  }

  suitabilityPerfilInformation(getPerfil?: boolean) {
    return of([]);
  }

  getTermsUse(account: string) {
    if (!account) {
      return of([]);
    }
    return this._httpService
      .doGet(this._configService.getTermSuitabilityURL(), 'terms_use/terms?user=' + account)
      .pipe(map(res => {
        return res;
      }));
  }

  postTermsUse(params: any) {
    if (!params) {
      return of([]);
    }
    return this._httpService
      .doPost(this._configService.getTermSuitabilityURL(), 'terms_use/sign', params, false)
      .pipe(map(res => {
        return res;
      }));
  }

}
